/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h } from "@stencil/core";
import { optimizeImageSrc } from "@rdss/core";
/**
 * SuggestionsSection is a functional component that creates a div with a role of "region".
 * It is used to wrap the suggestions section.
 * @returns {HTMLDivElement} A div element with part "suggestions-section".
 */
export const SuggestionsSection = (_, children) => h("div", { part: "suggestions-section", role: "region" }, children);
/**
 * Divider is a functional component that creates a div with a role of "presentation".
 * It is used to visually separate different sections.
 * @returns {HTMLDivElement} A div element with role "presentation" and class "divider".
 */
export const Divider = () => h("div", { role: "presentation", class: "divider" });
/**
 * SimpleSuggestions is a functional component that renders simple suggestions.
 * @returns {VNode} A div element with class "simple-suggestion-wrapper" containing the title and suggestions.
 */
export const SimpleSuggestions = ({ title, suggestions = [] }) => suggestions.length > 0 && (h("div", { class: "simple-suggestion-wrapper" }, h("div", { class: "suggestion-title" }, title), h("div", { class: "simple-suggestion-items" }, suggestions.map(({ link, highlighted }) => (h("a", { href: link, innerHTML: highlighted }))))));
/**
 * NoResults is a functional component that renders a message when there are no results.
 *
 * @param {object} props - The properties passed to the component.
 * @param {string} props.message - The message to display when there are no results.
 *
 * @returns {VNode} A div element with an aria-label attribute set to the message, and part attribute set to "no-results-message".
 */
export const NoResults = ({ message }) => h("div", { "aria-label": message, part: "no-results-message" }, message);
/**
 * ProductSuggestions is a functional component that renders product suggestions.
 * @returns {VNode | VNode[]} A div element with class "product-suggestion-items" containing the title and product suggestions.
 */
export const ProductSuggestions = ({ title, suggestions = [], imageOptions }) => suggestions.length > 0 && [
    h("div", { class: "suggestion-title" }, title),
    h("div", { class: "product-suggestion-items" }, suggestions.map(({ link, highlighted, cover, manufacturerName }) => (h("a", { href: link }, h("div", { class: "product-suggestion-item-wrapper" }, h("div", { class: "product-suggestion-item-image-wrapper" }, cover && (h("img", { class: "product-suggestion-image", style: { height: imageOptions.height + 'px' }, src: optimizeImageSrc(cover, imageOptions), alt: "" }))), h("div", { class: "product-suggestion-item-text-wrapper" }, h("span", { class: "product-suggestion-item-product-title", innerHTML: highlighted }), h("div", { class: "product-suggestion-item-text" }, manufacturerName))))))),
    h("vx-button", { type: "submit", height: "40px", fullwidth: true, raised: true }, "Alle Produkte anzeigen"),
];
//# sourceMappingURL=index.js.map
